// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"456":"49275524","587":"8dd1233a"}[chunkId] + ".chunk.css";
};